export const TAGS_LIST_API = '/tags/list';

export const TAG_DETAIL_API = '/tags/:id';
